module.exports = __webpack_public_path__ + "img/SKMJ_grinder2.cfd83b34.jpg";